import { useMutation } from '@tanstack/react-query';

import ProductsService, {
  SearchDto,
  SearchParams,
} from '@/services/ProductsService';

export function useSearchProducts() {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: ({
      searchDto,
      searchParams,
    }: {
      searchDto: SearchDto;
      searchParams: SearchParams;
    }) => ProductsService.searchProducts(searchDto, searchParams),
  });

  return {
    searchProducts: mutateAsync,
    isLoading: isPending,
  };
}
